import { useState } from "react";
import { CotaUsuario } from "../../../interfaces/CotaUsuario";
import { atualizarCotaUsuarioService } from "../../../services/atualizarCotaUsuarioService";

export const useTroca = () => {
  // Estados gerais
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const cadastrar = async (
    cotaUsuarioId: number,
    data: Partial<CotaUsuario>
  ) => {
    try {
      setLoading(true);

      const troca = await atualizarCotaUsuarioService(cotaUsuarioId, data);
      if (troca) {
        setSuccess("Alteração realizada com sucesso!");
      } else {
        setError("Erro ao realizar a alteração. Tente novamente.");
      }
    } catch (error) {
      setError("Erro ao realizar a alteração. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return { error, success, loading, resetError, resetSuccess, cadastrar };
};
